import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  public exportAsExcelFileOf2SheetsInvoice(json: any[], excelFileName: string): void {

    const worksheetForSheetData1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData1']);
    const worksheetForSheetData2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData2']);
    const workbook: XLSX.WorkBook = { Sheets: { 'Invoice List': worksheetForSheetData1, 'Invoice Service List': worksheetForSheetData2}, SheetNames: ['Invoice List', 'Invoice Service List'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  public exportAsExcelFileOf2SheetsQuotation(json: any[], excelFileName: string): void {

    const worksheetForSheetData1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData1']);
    const worksheetForSheetData2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData2']);
    const workbook: XLSX.WorkBook = { Sheets: { 'Quotation List': worksheetForSheetData1, 'Quotation Service List': worksheetForSheetData2}, SheetNames: ['Quotation List', 'Quotation Service List'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  public exportAsExcelFileOf2SheetsVendorPayments(json: any[], excelFileName: string): void {

    const worksheetForSheetData1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData1']);
    const worksheetForSheetData2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json['SheetData2']);
    const workbook: XLSX.WorkBook = { Sheets: { 'Purchase Entry List': worksheetForSheetData1, 'Purchase Return List': worksheetForSheetData2}, SheetNames: ['Purchase Entry List', 'Purchase Return List'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }




}